import type { Nullable } from '@/types/utils';

export const useWindowEventListener = <K extends keyof WindowEventMap>(
  type: K,
  cb: () => void,
  throttle: Nullable<number> = 1000,
) => {
  const fn = throttle ? useThrottleFn(cb, throttle) : cb;

  window.addEventListener(type, fn);

  // Cleaning up just for good measure
  window.addEventListener('beforeunload', () => {
    window.removeEventListener(type, fn);
  });
};
